import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { PreferenceSetEntity } from './preference-set.entity';
import { PreferenceEntity } from './preference.entity';

@Index('fk__preference__id', ['fkPreferenceId'], {})
@Index('fk__preference_set__id_default', ['fkPreferenceSetIdDefault'], {})
@Index('fk_company__id', ['fkCompanyId'], {})
@Entity('company_preference')
export class CompanyPreferenceEntity extends BaseEntity {
	@Column('int', { name: 'fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@Column('int', { name: 'fk__preference__id', unsigned: true })
	public fkPreferenceId!: number;

	@Column('int', {
		name: 'fk__preference_set__id_default',
		nullable: true,
		unsigned: true,
	})
	public fkPreferenceSetIdDefault!: number | null;

	@ManyToOne(() => CompanyEntity, (company) => company.companyPreferences, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public fkCompany!: CompanyEntity;

	@ManyToOne(
		() => PreferenceEntity,
		(preference) => preference.companyPreferences,
		{
			onDelete: 'NO ACTION',
			onUpdate: 'NO ACTION',
		},
	)
	@JoinColumn([{ name: 'fk__preference__id', referencedColumnName: 'id' }])
	public fkPreference!: PreferenceEntity;

	@ManyToOne(
		() => PreferenceSetEntity,
		(preferenceSet) => preferenceSet.companyPreferences,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: 'fk__preference_set__id_default', referencedColumnName: 'id' },
	])
	public fkPreferenceSetIdDefault2!: PreferenceSetEntity;
}
